import { fonts } from '@/constants';

export const generateFontSizeOptions = () => {
  const startSize = 48;
  const endSize = 150;
  const step = 2;

  const fontSizes = [];
  let currentSize = startSize;

  while (currentSize <= endSize) {
    fontSizes.push({
      value: String(currentSize),
      label: String(currentSize)
    });
    currentSize += step;
  }
  return fontSizes;
};

const loadFont = async (font: (typeof fonts)[number]): Promise<void> => {
  const fontFace = new FontFace(font.value, `url(${font.url})`, {
    style: 'normal',
    weight: 'normal'
  });
  document.fonts.add(fontFace);

  await fontFace.load();
  await document.fonts.load(`16px "${font.value}"`);
};

export const loadFonts = async (): Promise<void> => {
  const fontsToLoad = fonts.filter(
    (font) => font.url && !document.fonts.check(`16px "${font.value}"`)
  );

  // Load in parallel so one failing font doesn't block the others.
  const results = await Promise.allSettled(fontsToLoad.map(loadFont));
  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      console.error(`Failed to load font "${fontsToLoad[index].value}"`, result.reason);
    }
  });
};
